// @flow

import React from 'react';
import { colors } from 'seedling/constants';

import type { Node } from 'react';

const FilterIcon = ({
  color,
  size,
  className,
}: {
  color?: string,
  size?: ?number,
  className?: ?string,
}): Node => {
  return (
    <svg
      height={size}
      width={size}
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Filter</title>
      <path
        fill={color}
        d="M7.89598411,9.69666763 L3.15626298,3.67245203 C2.78135859,3.19594617 3.12341386,2.5 3.73251931,2.5 L16.2674887,2.5 C16.8747079,2.5 17.2173147,3.19216875 16.8462433,3.66925841 L12.1599946,9.69440859 L12.1599946,15.0903086 C12.1599946,15.3442667 12.0262593,15.5797512 11.8073645,15.7112286 L9.00567949,17.394039 C8.51839338,17.6867236 7.89598411,17.3384601 7.89598411,16.773119 L7.89598411,9.69666763 Z M5.23123527,3.95150362 L9.20340318,9.00015421 C9.30378398,9.12773884 9.35830957,9.28497312 9.35830957,9.44685443 L9.35830957,15.4856691 L10.6976692,14.6811931 L10.6976692,9.44685443 C10.6976692,9.2863583 10.7512669,9.13038914 10.8500773,9.00334783 L14.7793068,3.95150362 L5.23123527,3.95150362 Z"
      />
    </svg>
  );
};

FilterIcon.defaultProps = {
  size: 20,
  color: colors.mediumGrey,
};

export default FilterIcon;
